import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { QRCodeSVG as QRCode } from 'qrcode.react';
import { Check } from 'lucide-react';
// import bgImage from '../img/ID_BKG.jpeg';
import bgImage from '../img/idcardback.png';
import logoImage from '../img/spllogo.png'; 
// import logoImage from '../img/mainlogoforidcard.jpeg'; 


import "./Profile.css";

const Adminprofile = () => {
  const [userData, setUserData] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [tournaments, setTournaments] = useState([]);
  const [mealDistribution, setMealDistribution] = useState([
    { id: 1, date: '2025-10-29', breakfast: true, lunch: true, hiTea: true, dinner: false },
    { id: 2, date: '2025-10-30', breakfast: true, lunch: false, hiTea: false, dinner: false },
    { id: 3, date: '2025-10-31', breakfast: false, lunch: false, hiTea: false, dinner: false },
    { id: 4, date: '2025-11-01', breakfast: false, lunch: false, hiTea: false, dinner: false },
    { id: 5, date: '2025-11-02', breakfast: false, lunch: false, hiTea: false, dinner: false }
  ]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [qrData, setQrData] = useState('');
  const [qrLoading, setQrLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const navigate = useNavigate();
  const idCardRef = useRef(null);

  // Get user photo URL - for PAGE DISPLAY
  const getUserPhotoUrl = (userData) => {
    if (!userData) {
      console.log('getUserPhotoUrl: No userData');
      return null;
    }

    console.log('=== CHECKING PHOTO FIELDS ===');
    console.log('User data keys:', Object.keys(userData));

    const photoFields = [
      'photoPath', 'PhotoPath',
      'photo', 'Photo',
      'photoUrl', 'PhotoUrl', 'PhotoURL',
      'image', 'Image',
      'imageUrl', 'ImageUrl', 'ImageURL',
      'profilePicture', 'ProfilePicture',
      'profilePhoto', 'ProfilePhoto',
      'avatar', 'Avatar',
      'picture', 'Picture'
    ];

    for (const field of photoFields) {
      if (userData[field] && userData[field].toString().trim()) {
        const photoValue = userData[field].toString().trim();
        console.log(`✓ Found ${field}:`, photoValue);

        if (photoValue.startsWith('http://') || photoValue.startsWith('https://')) {
          console.log('→ Using full URL:', photoValue);
          return photoValue;
        }

        if (photoValue.startsWith('data:image')) {
          console.log('→ Using base64');
          return photoValue;
        }

        if (photoValue.startsWith('/')) {
          const baseUrl = "https://api.asterickx.com";
          const fullUrl = `${baseUrl}${photoValue}`;
          console.log('→ Constructed URL from relative path:', fullUrl);
          return fullUrl;
        }

        const baseUrl = "https://api.asterickx.com";
        const fullUrl = `${baseUrl}/uploads/${photoValue}`;
        console.log('→ Constructed from filename:', fullUrl);
        return fullUrl;
      }
    }

    console.log('✗ No photo field found in userData');
    console.log('Available fields:', Object.keys(userData).join(', '));
    return null;
  };

  // Get phone/mobile number
  const getUserPhone = (userData) => {
    if (!userData) return null;
    const phoneFields = ['phoneNumber', 'PhoneNumber', 'phone', 'Phone', 'mobile', 'Mobile', 'mobileNumber', 'MobileNumber', 'contactNumber'];
    for (const field of phoneFields) {
      if (userData[field] && userData[field].toString().trim()) {
        return userData[field].toString().trim();
      }
    }
    return null;
  };

  // Get state
  const getUserState = (userData) => {
    if (!userData) return null;
    const stateFields = ['state', 'State', 'stateName', 'StateName'];
    for (const field of stateFields) {
      if (userData[field] && userData[field].toString().trim()) {
        return userData[field].toString().trim();
      }
    }
    return null;
  };

  // Decode JWT
  const decodeJWT = (token) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Error decoding JWT:', error);
      return null;
    }
  };

  // Download ID card as PDF
const downloadIDCard = async () => {
  if (!idCardRef.current) {
    alert('ID card not found');
    return;
  }

  try {
    setDownloading(true);

    const storedUser = localStorage.getItem('user');
    const token =
      localStorage.getItem('token') ||
      localStorage.getItem('Token') ||
      (storedUser ? JSON.parse(storedUser)?.token : null);

    const currentUserData = userDetails || userData;
    const userId =
      currentUserData?.id ||
      currentUserData?.userId ||
      currentUserData?.memberId ||
      currentUserData?.ID;

    // STEP 1: Fetch base64 photo so html2canvas can read it without CORS issues
    let imageBase64 = null;
    if (userId) {
      try {
        const res = await fetch(
          `https://api.asterickx.com/api/Members/members/photo/${userId}`,
          { method: 'GET', headers: { Authorization: `Bearer ${token}` } }
        );
        if (res.ok) {
          const data = await res.json();
          if (data.base64) imageBase64 = data.base64;
        }
      } catch (e) {
        console.warn('Photo fetch failed, will try existing src', e);
      }
    }

    // STEP 2: Swap profile photo src to base64 on the LIVE card (no clone)
    const profileImg = idCardRef.current.querySelector('img[alt="Profile"]');
    let originalSrc = null;
    if (imageBase64 && profileImg) {
      originalSrc = profileImg.src;
      profileImg.src = imageBase64.startsWith('data:image')
        ? imageBase64
        : `data:image/jpeg;base64,${imageBase64}`;
      // Wait for the swap to settle
      await new Promise(r => {
        if (profileImg.complete) { r(); return; }
        profileImg.onload = r;
        profileImg.onerror = r;
      });
    }

    // STEP 3: Hide the download button (on the live card, temporarily)
    const btnContainer = idCardRef.current.querySelector('[data-exclude-from-capture]');
    if (btnContainer) btnContainer.style.visibility = 'hidden';

    // Give the browser one frame to repaint
    await new Promise(r => requestAnimationFrame(() => setTimeout(r, 100)));

    // STEP 4: Capture — operate directly on the live element, no clone, no transform
    const card = idCardRef.current;
    const { width, height } = card.getBoundingClientRect();

    const canvas = await html2canvas(card, {
      scale: 4,                  // 4× = crisp on Retina + high-res PDF
      useCORS: true,
      allowTaint: true,          // needed so backgroundImage renders
      backgroundColor: null,     // preserve the card's own background
      logging: false,
      imageTimeout: 20000,
      width: Math.round(width),
      height: Math.round(height),
      // Scroll offset correction (in case the card is partially scrolled)
      scrollX: -window.scrollX,
      scrollY: -window.scrollY,
      onclone: (_doc, el) => {
        // Remove the button from the cloned DOM that html2canvas uses internally
        const btn = el.querySelector('[data-exclude-from-capture]');
        if (btn) btn.remove();
        // Ensure all images are visible
        el.querySelectorAll('img').forEach(img => {
          img.style.visibility = 'visible';
          img.style.opacity = '1';
          img.style.display = 'block';
        });
      },
    });

    // STEP 5: Restore original state immediately after capture
    if (originalSrc && profileImg) profileImg.src = originalSrc;
    if (btnContainer) btnContainer.style.visibility = 'visible';

    // STEP 6: Build PDF — derive height from actual aspect ratio, never hardcode
    const cardWidthMm = 100;
    const cardHeightMm = Math.round(cardWidthMm * (height / width));

    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [cardWidthMm, cardHeightMm],
      compress: true,
    });

    // PNG = lossless, no JPEG re-compression artifacts
    const imgData = canvas.toDataURL('image/png');
    pdf.addImage(imgData, 'PNG', 0, 0, cardWidthMm, cardHeightMm);

    const userName = (
      displayUserData?.firstName ||
      displayUserData?.name ||
      'User'
    ).replace(/[^a-zA-Z0-9]/g, '_');

    pdf.save(`ID_Card_${userName}_${Date.now()}.pdf`);

  } catch (err) {
    console.error('Download error:', err);
    alert(`Failed to generate PDF: ${err.message}`);
  } finally {
    setTimeout(() => setDownloading(false), 500);
  }
};

  // Generate QR
  const generateQRData = async (userId) => {
    try {
      setQrLoading(true);
      const baseUrl = window.location.origin;
      const qrUrl = `${baseUrl}/userqr?id=${userId}`;
      setQrData(qrUrl);
      return qrUrl;
    } catch (error) {
      const fallbackUrl = `${window.location.origin}/userqr?id=${userId}`;
      setQrData(fallbackUrl);
      return fallbackUrl;
    } finally {
      setQrLoading(false);
    }
  };

  useEffect(() => {
    console.log('=== AUTHENTICATION CHECK STARTED ===');

    const storedUser = localStorage.getItem('user');
    const token = localStorage.getItem('token') ||
      localStorage.getItem('Token') ||
      (storedUser ? JSON.parse(storedUser).token : null);

    if (!token) {
      console.log('❌ NO TOKEN FOUND - Redirecting to login');
      alert('NO TOKEN FOUND! Check console for localStorage contents.');
    }

    try {
      console.log('🔓 Attempting to decode JWT...');
      const decodedToken = decodeJWT(token);

      if (!decodedToken) {
        console.log('❌ INVALID TOKEN');
        alert('INVALID TOKEN! Check console.');
      }

      console.log('✅ Token decoded successfully:', decodedToken);

      const userFromToken = {
        id: decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'] ||
          decodedToken.sub || decodedToken.userId,
        email: decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'] ||
          decodedToken.email,
        name: decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'] ||
          decodedToken.name,
        exp: decodedToken.exp
      };

      console.log('👤 User from token:', userFromToken);

      if (userFromToken.exp) {
        const isExpired = Date.now() >= userFromToken.exp * 1000;
        if (isExpired) console.log('❌ TOKEN EXPIRED');
      }

      setUserData(userFromToken);

      if (!userFromToken.id) {
        console.log('❌ No user ID found in token');
        setError('User ID not found');
        setLoading(false);
        return;
      }

      fetchUserDetails(userFromToken.id, token);
      generateQRData(userFromToken.id);

    } catch (parseError) {
      console.error('❌ ERROR PARSING TOKEN:', parseError);
      alert('ERROR PARSING TOKEN: ' + parseError.message);
    }
  }, [navigate]);

  const fetchUserDetails = async (userId, token) => {
    try {
      setLoading(true);
      setError(null);

      const apiUrl = `https://api.asterickx.com/api/Members/${userId}`;
      const headers = { 'Content-Type': 'application/json' };
      if (token) headers['Authorization'] = `Bearer ${token}`;

      const userResponse = await fetch(apiUrl, { method: 'GET', headers, mode: 'cors' });

      if (userResponse.ok) {
        const userDetailsData = await userResponse.json();
        console.log('=== MEMBERS API SUCCESS ===', userDetailsData);
        setUserDetails(userDetailsData);
      } else if (userResponse.status === 401) {
        setError('Session expired. Redirecting...');
        localStorage.clear();
        setTimeout(() => navigate('/login'), 2000);
        return;
      } else {
        setError(`Failed: ${userResponse.status}`);
      }

      try {
        const [playerRegistrationsResponse, tournamentsResponse, teamsResponse] = await Promise.all([
          fetch('https://api.asterickx.com/api/PlayerRegistrations/', {
            headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
          }),
          fetch('https://api.asterickx.com/api/Tournament', {
            headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
          }),
          fetch('https://api.asterickx.com/api/Team', {
            headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
          })
        ]);

        let playerRegistrationsData = playerRegistrationsResponse.ok ? await playerRegistrationsResponse.json() : [];
        let allTournaments = tournamentsResponse.ok ? await tournamentsResponse.json() : [];
        let allTeams = teamsResponse.ok ? await teamsResponse.json() : [];

        const userRegistrations = Array.isArray(playerRegistrationsData)
          ? playerRegistrationsData.filter(reg => String(reg.playerId || reg.userId) === String(userId))
          : [];

        const tournamentMap = new Map();
        const teamMap = new Map();

        if (Array.isArray(allTournaments)) {
          allTournaments.forEach(t => {
            const id = t.id || t.tournamentId;
            if (id) { tournamentMap.set(String(id), t); tournamentMap.set(parseInt(id), t); }
          });
        }

        if (Array.isArray(allTeams)) {
          allTeams.forEach(t => {
            const id = t.id || t.teamId;
            if (id) { teamMap.set(String(id), t); teamMap.set(parseInt(id), t); }
          });
        }

        const tournamentData = userRegistrations.map(reg => {
          const tId = reg.tournamentId || reg.TournamentId;
          const teamId = reg.teamId || reg.TeamId;
          const tournament = tId ? (tournamentMap.get(String(tId)) || tournamentMap.get(parseInt(tId))) : null;
          const team = teamId ? (teamMap.get(String(teamId)) || teamMap.get(parseInt(teamId))) : null;
          return {
            id: reg.id,
            tournamentName: tournament?.name || `Tournament ${tId}` || 'Unknown',
            startDate: tournament?.startDate,
            endDate: tournament?.endDate,
            teamName: team?.name || `Team ${teamId}` || 'No Team',
            location: tournament?.location
          };
        });

        setTournaments(tournamentData);
      } catch (err) {
        console.error('Tournament error:', err);
      }

    } catch (error) {
      console.error('Fetch error:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return isNaN(date.getTime()) ? 'Invalid Date' : date.toLocaleDateString('en-US', {
        year: 'numeric', month: 'short', day: 'numeric'
      });
    } catch { return 'Invalid Date'; }
  };

  const formatDayDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return isNaN(date.getTime()) ? 'Invalid Date' : date.toLocaleDateString('en-US', {
        weekday: 'short', month: 'short', day: 'numeric'
      });
    } catch { return 'Invalid Date'; }
  };

  if (loading) {
    return (
      <div className="container mt-5">
        <div className="text-center">
          <div className="spinner-border"></div>
          <p className="mt-2">Loading profile...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger">
          <h4>Error Loading Profile</h4>
          <p>{error}</p>
          <button className="btn btn-primary" onClick={() => window.location.reload()}>Retry</button>
        </div>
      </div>
    );
  }

  const displayUserData = userDetails || userData;
  const userPhotoUrl = getUserPhotoUrl(displayUserData);
  const userPhone = getUserPhone(displayUserData);
  const userState = getUserState(displayUserData);

  console.log('=== RENDERING ===');
  console.log('Photo URL:', userPhotoUrl);

  return (
    <div className="container mt-5" style={{ marginBottom: '80px' }}>
      <div className="row">
        <div className="col-md-3 mb-4">
          <div
            ref={idCardRef}
            className="card shadow h-100"
            style={{
              backgroundImage: `url(${bgImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              overflow: 'hidden',
              position: 'relative',
              borderRadius: '12px'
            }}
          >
            {/* ── Dark overlay so background image doesn't overpower text ── */}
            <div style={{
              position: 'absolute',
              top: 0, left: 0, right: 0, bottom: 0,
              background: 'rgba(0, 0, 0, 0.50)',
              zIndex: 0
            }} />

            {/* ── LOGO SECTION (replaces old commented card-header) ── */}
            <div
              data-logo-section="true"
              style={{
                position: 'relative',
                zIndex: 1,
                // background: 'rgba(255, 255, 255, 0.13)',
                // borderBottom: '1px solid rgba(255,255,255,0.18)',
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px'
              }}
            >
              {/*
                ── TO USE A REAL LOGO IMAGE: ──
                1. Uncomment the import at the top: import logoImage from '../img/logo.png';
                2. Replace the block below with:
                   <img src={logoImage} alt="Logo" style={{ height: '48px', width: 'auto', objectFit: 'contain' }} />

                ── DEFAULT STYLED LOGO (no image needed): ──
              */}
              <img src={logoImage} alt="Logo" style={{ height: '50px', width: 'auto', objectFit: 'contain' }} />
              {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <span style={{
                  color: '#ffffff',
                  fontWeight: 700,
                  fontSize: '13px',
                  letterSpacing: '0.3px',
                  lineHeight: 1.2,
                  textShadow: '0 1px 3px rgba(0,0,0,0.6)'
                }}>
                  BADMINTON INDIA
                </span>
                <span style={{
                  color: 'rgba(255,255,255,0.65)',
                  fontSize: '9px',
                  fontWeight: 600,
                  letterSpacing: '0.6px',
                  textTransform: 'uppercase'
                }}>
                  Official Association
                </span>
              </div> */}
            </div>

            {/*
              ── COMMENTED OUT as requested ──
              <div className="card-header text-center border-0" style={{ background: 'rgba(255, 255, 255, 0.14)', position: 'relative', zIndex: 1, color: 'white'}}>
                <h6 className="mb-0">Yonex-Sunrise 4th Mini National Badminton Championship-2025 Baroda</h6>
              </div>
            */}

            <div className="card-body text-center" style={{ position: 'relative', zIndex: 1, color: '#f0f0f0' }}>

              {/* ── PROFILE PHOTO ── */}
              <div className="mb-3">
                <div
                  className="rounded-circle d-inline-flex align-items-center justify-content-center overflow-hidden"
                  style={{
                    width: '120px',
                    height: '120px',
                    border: '4px solid rgba(255,255,255,0.75)',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.4)',
                    position: 'relative',
                    // Frosted glass look when photo is absent
                    background: 'rgba(255,255,255,0.15)',
                    backdropFilter: 'blur(6px)',
                    WebkitBackdropFilter: 'blur(6px)'
                  }}
                >
                  {userPhotoUrl ? (
                    <>
                      <img
                        src={userPhotoUrl}
                        alt="Profile"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          position: 'absolute',
                          top: 0, left: 0,
                          display: 'block',
                          // Slight opacity so photo feels part of the card, not pasted on
                          opacity: 0.9
                        }}
                        onLoad={(e) => {
                          console.log('✓✓✓ Photo loaded successfully');
                          e.target.style.opacity = '0.9';
                        }}
                        onError={(e) => {
                          console.error('✗✗✗ Photo failed to load');
                          e.target.style.display = 'none';
                          const parent = e.target.parentElement;
                          if (parent && !parent.querySelector('.fa-user')) {
                            const icon = document.createElement('i');
                            icon.className = 'fas fa-user fa-3x text-white';
                            icon.style.position = 'relative';
                            icon.style.zIndex = '1';
                            parent.appendChild(icon);
                          }
                        }}
                      />
                      {/* Subtle vignette ring over photo */}
                      <div style={{
                        position: 'absolute', inset: 0, borderRadius: '50%',
                        boxShadow: 'inset 0 0 12px rgba(0,0,0,0.25)',
                        zIndex: 1, pointerEvents: 'none'
                      }} />
                    </>
                  ) : (
                    <i className="fas fa-user fa-2x" style={{ color: 'rgba(255,255,255,0.7)' }}></i>
                  )}
                </div>
              </div>

              {/* ── NAME & INFO ── */}
              <div className="mb-4">
                <h5 className="mb-1" style={{ textShadow: '0 1px 4px rgba(0,0,0,0.7)', fontWeight: 700 }}>
                  {displayUserData?.firstName && displayUserData?.lastName
                    ? `${displayUserData.firstName} ${displayUserData.lastName}`
                    : displayUserData?.name || 'N/A'}
                </h5>
                {userPhone && (
                  <p className="mb-1">
                    <i className="fas fa-phone me-2"></i>
                    <small className="fw-semibold">{userPhone}</small>
                  </p>
                )}
                {userState && (
                  <p className="mb-1">
                    <i className="fas fa-map-marker-alt me-2"></i>
                    <small className="fw-semibold">{userState}</small>
                  </p>
                )}
              </div>

              {/* ── QR CODE ── */}
              <div className="mb-4">
                <div className="bg-white p-3 rounded d-inline-block" style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.3)' }}>
                  {qrData ? (
                    <QRCode value={qrData} size={120} level="M" />
                  ) : (
                    <div style={{ width: '120px', height: '120px' }} className="d-flex align-items-center justify-content-center">
                      <div className="spinner-border text-primary"></div>
                    </div>
                  )}
                </div>
                <p className="mt-2 mb-0"><small className="opacity-75">Scan for details</small></p>
              </div>

              {/* ── DOWNLOAD BUTTON ── */}
              <div className="gap-2" data-exclude-from-capture="true">
                <button className="btn btn-primary fw-bold" onClick={downloadIDCard} disabled={downloading}>
                  {downloading ? (
                    <><div className="spinner-border spinner-border-sm me-2"></div>Downloading...</>
                  ) : (
                    <><i className="fas fa-download me-2"></i>Download ID Card</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* ── TOURNAMENTS TABLE ── */}
        <div className="col-md-9 mb-4">
          <div className="card shadow">
            <div className="card-header text-white" style={{ backgroundColor: '#3069B5' }}>
              <h4 className="mb-0"><i className="fas fa-trophy me-2"></i>Tournament Registrations</h4>
            </div>
            <div className="card-body">
              {tournaments.length === 0 ? (
                <div className="text-center text-muted py-5">
                  <i className="fas fa-info-circle fa-3x mb-3"></i>
                  <h5>No tournaments registered yet</h5>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover table-striped">
                    <thead className="table-dark">
                      <tr>
                        <th>#</th>
                        <th>Tournament Name</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Team Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tournaments.map((t, i) => (
                        <tr key={t.id || i}>
                          <td>{i + 1}</td>
                          <td>
                            <strong>{t.tournamentName}</strong>
                            {t.location && <small className="d-block text-muted">{t.location}</small>}
                          </td>
                          <td><span className="badge bg-info">{formatDate(t.startDate)}</span></td>
                          <td><span className="badge bg-info">{formatDate(t.endDate)}</span></td>
                          <td><span className="fw-bold text-primary">{t.teamName}</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <div className="row">
        <div className="col-12 mb-4">
          <div className="card shadow">
            <div className="card-header text-white" style={{ backgroundColor: '#3069B5' }}>
              <h4 className="mb-0"><i className="fas fa-utensils me-2"></i>Meal Distribution</h4>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead className="table-dark">
                    <tr>
                      <th>Day</th>
                      <th className="text-center"><i className="fas fa-coffee me-1"></i>Breakfast</th>
                      <th className="text-center"><i className="fas fa-hamburger me-1"></i>Lunch</th>
                      <th className="text-center"><i className="fas fa-mug-hot me-1"></i>Hi-Tea</th>
                      <th className="text-center"><i className="fas fa-moon me-1"></i>Dinner</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mealDistribution.map((day) => (
                      <tr key={day.id}>
                        <td><strong>{formatDayDate(day.date)}</strong></td>
                        <td className="text-center">
                          {day.breakfast ? <Check size={24} className="text-primary" /> : <span className="text-muted">—</span>}
                        </td>
                        <td className="text-center">
                          {day.lunch ? <Check size={24} className="text-primary" /> : <span className="text-muted">—</span>}
                        </td>
                        <td className="text-center">
                          {day.hiTea ? <Check size={24} className="text-primary" /> : <span className="text-muted">—</span>}
                        </td>
                        <td className="text-center">
                          {day.dinner ? <Check size={24} className="text-primary" /> : <span className="text-muted">—</span>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Adminprofile;